import { SelectInput, SelectInputItem } from '@ads/components-react';
import { useTranslation } from 'react-i18next';
import type { SlideCategory } from '../../../store/atoms/slideCategoriesAtom';

export interface CategorySelectorProps {
  /** Categorias disponíveis para seleção. */
  readonly categories: SlideCategory[];
  /** Id da categoria atualmente selecionada (`undefined` = nenhuma). */
  readonly categoryId: number | undefined;
  /** Chamado quando o usuário escolhe uma categoria válida (`id > 0`). */
  readonly onCategoryChange: (id: number) => void;
}

/**
 * Seletor de categoria do slide, baseado no `SelectInput` do design system.
 *
 * Substitui o `<select>` nativo da top bar por um dropdown consistente com o
 * resto da aplicação (mesmo padrão do `LanguageSelector`), com placeholder
 * quando nenhuma categoria está selecionada.
 *
 * @param props - Categorias, seleção atual e callback de mudança
 */
export function CategorySelector({
  categories,
  categoryId,
  onCategoryChange,
}: CategorySelectorProps) {
  const { t } = useTranslation('slideEditor');

  return (
    <SelectInput
      value={categoryId !== undefined ? String(categoryId) : ''}
      onValueChange={value => {
        const id = Number(value);
        if (!Number.isNaN(id) && id > 0) onCategoryChange(id);
      }}
      placeholder={t('topBar.categoryPlaceholder')}
      aria-label={t('topBar.categoryPlaceholder')}
      size="md"
      fullWidth
    >
      {categories.map(cat => (
        <SelectInputItem custom={{ root: 'text-nowrap' }} key={cat.id} value={String(cat.id)}>
          {cat.name}
        </SelectInputItem>
      ))}
    </SelectInput>
  );
}
